import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-deep-blue">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <Link to="/">
                <img 
                  className="h-12" 
                  src="/images/protec_logo_updated.png" 
                  alt="Protec Services & Distribution" 
                />
              </Link>
            </div>
          </div>
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-4">
              <Link to="/" className="text-white font-montserrat font-medium uppercase tracking-wider px-3 py-2 hover:bg-blue-800 rounded-md">
                Home
              </Link>
              <Link to="/about" className="text-white font-montserrat font-medium uppercase tracking-wider px-3 py-2 hover:bg-blue-800 rounded-md">
                About Us
              </Link>
              <Link to="/services" className="text-white font-montserrat font-medium uppercase tracking-wider px-3 py-2 hover:bg-blue-800 rounded-md">
                Services
              </Link>
              <Link to="/contact" className="text-white font-montserrat font-medium uppercase tracking-wider px-3 py-2 hover:bg-blue-800 rounded-md">
                Contact
              </Link>
            </div>
          </div>
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:bg-blue-800 focus:outline-none"
            >
              <svg 
                className={`${isOpen ? 'hidden' : 'block'} h-6 w-6`} 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor" 
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
              <svg 
                className={`${isOpen ? 'block' : 'hidden'} h-6 w-6`} 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor" 
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`${isOpen ? 'block' : 'hidden'} md:hidden`}>
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
          <Link 
            to="/" 
            className="text-white block font-montserrat font-medium uppercase tracking-wider px-3 py-2 hover:bg-blue-800 rounded-md"
            onClick={() => setIsOpen(false)}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className="text-white block font-montserrat font-medium uppercase tracking-wider px-3 py-2 hover:bg-blue-800 rounded-md"
            onClick={() => setIsOpen(false)}
          >
            About Us
          </Link>
          <Link 
            to="/services" 
            className="text-white block font-montserrat font-medium uppercase tracking-wider px-3 py-2 hover:bg-blue-800 rounded-md"
            onClick={() => setIsOpen(false)}
          >
            Services
          </Link>
          <Link 
            to="/contact" 
            className="text-white block font-montserrat font-medium uppercase tracking-wider px-3 py-2 hover:bg-blue-800 rounded-md"
            onClick={() => setIsOpen(false)}
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
